export default __webpack_public_path__ + "static/media/3.87997281.png";